import MyDistributeChildren from './my-micro-app/route-config';
import MyDistributeFunc from './my-micro-app/index';
import RuleCollection from './rule-collection';
import MaterialManageDaily from './material-manage';
import MyMaterialChildren from './material-manage/route-config';
import { DAILY_ACTIVITY_MANAGE } from '@/constants/frontend-menus';
import RuleIconText from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-icon';
import InviteIconText from '@/pages/platform-marketing-position/resource-detail/material-collection/components/invite-icon';

export default [
  {
    path: '/distribute',
    title: '分配提报',
    dynamicChild: true,
    component: MyDistributeFunc,
    menus: MyDistributeChildren,
    jumpType: 3, // 0：无效   1：新开页  2：当前页面刷新 3：当前页面不刷新
    injectType: 1,
  },
  {
    path: '/rule-collection',
    title: <RuleIconText />,
    component: RuleCollection,
    jumpType: 3, // 0：无效   1：新开页  2：当前页面刷新 3：当前页面不刷新
    injectType: 1,
  },
  {
    path: '/invite',
    title: <InviteIconText />,
    dynamicChild: true,
    component: MyDistributeFunc,
    menus: MyDistributeChildren,
    jumpType: 3, // 0：无效   1：新开页  2：当前页面刷新 3：当前页面不刷新
    injectType: 1,
  },
  {
    path: '/manage',
    title: '我的素材',
    menuId: DAILY_ACTIVITY_MANAGE,
    dynamicChild: true,
    component: MaterialManageDaily,
    menus: MyMaterialChildren,
    jumpType: 3, // 0：无效   1：新开页  2：当前页面刷新 3：当前页面不刷新
    injectType: 1,
  },
];
